import { APICore } from "./apiCore";

const api = new APICore();

// ── Categorias ──────────────────────────────────────────────────────────────

const listarCategoriasAnamnese = (params?: {
  currentPage?: number;
  pageSize?: number;
  search?: string;
}) => {
  return api.get("/anamnese-categoria", params);
};

const obterCategoriaPorId = (id: string | number) => {
  return api.get(`/anamnese-categoria/${id}`);
};

const criarCategoriaAnamnese = (params: {
  nome: string;
  ativo?: boolean;
  ordem?: number;
}) => {
  return api.create("/anamnese-categoria", params);
};

const atualizarCategoriaAnamnese = (
  id: string | number,
  params: { nome?: string; ativo?: boolean; ordem?: number }
) => {
  return api.update(`/anamnese-categoria/${id}`, params);
};

const excluirCategoriaAnamnese = (id: string | number) => {
  return api.delete(`/anamnese-categoria/${id}`);
};

// ── Perguntas ────────────────────────────────────────────────────────────────

const listarPerguntasAnamnese = (params?: {
  categoria_id?: number;
  currentPage?: number;
  pageSize?: number;
  search?: string;
}) => {
  return api.get("/anamnese-pergunta", params);
};

const obterPerguntaPorId = (id: string | number) => {
  return api.get(`/anamnese-pergunta/${id}`);
};

const criarPerguntaAnamnese = (params: {
  enunciado: string;
  tipo: "textarea" | "boolean" | "multipla_escolha";
  opcoes?: string[];
  obrigatorio?: boolean;
  ordem?: number;
  ativo?: boolean;
  anamnese_categoria_id: number;
}) => {
  return api.create("/anamnese-pergunta", params);
};

const atualizarPerguntaAnamnese = (
  id: string | number,
  params: {
    enunciado?: string;
    tipo?: "textarea" | "boolean" | "multipla_escolha";
    opcoes?: string[];
    obrigatorio?: boolean;
    ordem?: number;
    ativo?: boolean;
    anamnese_categoria_id?: number;
  }
) => {
  return api.update(`/anamnese-pergunta/${id}`, params);
};

const excluirPerguntaAnamnese = (id: string | number) => {
  return api.delete(`/anamnese-pergunta/${id}`);
};

// ── Respostas ────────────────────────────────────────────────────────────────

const listarRespostasAnamnese = (pacienteId: string | number) => {
  return api.get(`/anamnese-resposta/paciente/${pacienteId}`);
};

const salvarRespostasAnamnese = (
  pacienteId: string | number,
  respostas: Array<{ anamnese_pergunta_id: number; valor: any }>
) => {
  return api.update(`/anamnese-resposta/paciente/${pacienteId}`, { respostas });
};

export {
  listarCategoriasAnamnese,
  obterCategoriaPorId,
  criarCategoriaAnamnese,
  atualizarCategoriaAnamnese,
  excluirCategoriaAnamnese,
  listarPerguntasAnamnese,
  obterPerguntaPorId,
  criarPerguntaAnamnese,
  atualizarPerguntaAnamnese,
  excluirPerguntaAnamnese,
  listarRespostasAnamnese,
  salvarRespostasAnamnese,
};
